export default { 
    error: {
        back_to_main_page : "back to main page", 
        return_main_page: "Please return to the main page. to make a new transaction again", 
    }, 
}
